//get accesspoint id from the url, call the api to get the hub relays for the accesspoint id and show in a primereact datatable
import React, { useState, useEffect, useRef  } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { config } from '../config.js';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import Container from 'react-bootstrap/Container';
import {InputSwitch} from 'primereact/inputswitch';
import { useAuth } from '../contexts/AuthContext.js';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

import '../config.js'

const StaffMembers = () => {
  // Load the status page script
  useStatusPageScript();
  
    const { type, typeId } = useParams();
    const [staffMembers, setStaffMembers] = useState([]);
    const {relayStatus, setRelayStatus} = useState([]);
    const [hubRelay, setHubRelay] = useState({});
    const [displayDialog, setDisplayDialog] = useState(false);
    const [displayDialogDelete, setDisplayDialogDelete] = useState(false);
    const [newHubRelay, setNewHubRelay] = useState(false);
    const [newMemberNumber, setNewMemberNumber] = useState('');
    const [newHubId, setNewHubId] = useState('');
    const [newThisLocation, setNewThisLocation] = useState(true);
    const [newOverrideLMS, setNewOverrideLMS] = useState(false);
    const [editAllowed, setEditAllowed] = useState(true);
    const [selectedStaffMember, setSelectedStaffMember] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const toastBC = useRef(null);
    const msgs = useRef(null);
    const [loading, setLoading] = useState(true);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const dt = useRef(null);
    const navigate = useNavigate();
    useAuth();
    const [statuses] = useState(["true", "false"]);
    const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect();
    const [keypadEnabled, setKeypadEnabled] = useState(false);
    const [editOverrideLMS, setEditOverrideLMS] = useState(true);

    useEffect(() => {
        const fetchStaffMembers = async () => {
            await getStaffMembers();
          };
      
          fetchStaffMembers();
        //   returnTable
    }
    , [typeId, relayStatus]);

    const getStaffMembers = async () => {
        clearAccessIssue();
        setLoading(true);
        const token = localStorage.getItem('token');
        let header = {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }

        axios.get(`${global.config.url}/staffmembers/by${type}/${typeId}`, header)
            .then(response => {
                setStaffMembers(response.data);
                setLoading(false);
            })
            .catch(async error => {
                if (handleAccessError(error)) {
                    setLoading(false);
                    return;
                }
                setError(error.message);
                setLoading(false);
            })
        // axios.get(`${global.config.url}/ajaxrelay/status/${typeId}`, header)
        // .then(response => {
        //     console.log(response.data);
        //     setRelayStatus(response.data);
        // })
        // .catch(async error => {
        //     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        //         setShowLoginModal(true);
        //     }
        //     setError(error.message);
        // })
    }



    const handleAdd = () => {
        if(type == "customer"){
            msgs.current.show({severity: 'error', summary: '', detail: 'Get Staff Members by Location to be able to add one.'});
            return;
        }
        setNewHubRelay(true);
        setHubRelay({});
        setSubmitted(false);
        setDisplayDialog(true);
    }

    const onRowEditComplete = (rowData) => {
        confirm(null, rowData);
    }

    const confirm = (create, newdata) => {
        if(create === null){
          toastBC.current.show({
            severity: 'info',
            sticky: true,
            className: 'border-none',
            content: (
                <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                        <div className="font-bold text-xl my-3">Are you sure?</div>
                    </div>
                    <div className="flex align-items-center">
                        <Button onClick={(e) => handleSave(newdata)} type="button" label="Confirm" className="p-button-success w-6rem" />
                        <Button onClick={(e) => handleCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                    </div>
                </div>
            )
          });
        }
        else{
          if(create){
            if(newMemberNumber === null || newMemberNumber  === undefined || newMemberNumber === ''){
              toast.current.show({severity: 'error', summary: '', detail: 'Please enter a new Relay Id.'});
              return;
            }
            toastBC.current.show({
              severity: 'info',
              sticky: true,
              className: 'border-none',
              content: (
                  <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                      <div className="text-center">
                          <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                          <div className="font-bold text-xl my-3">Are you sure?</div>
                      </div>
                      <div className="flex align-items-center">
                          <Button onClick={(e) => handleSave(null)} type="button" label="Confirm" className="p-button-success w-6rem" />
                          <Button onClick={(e) => handleCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                      </div>
                  </div>
              )
            });
          }
          else{
            setDeleteLoading(true);
            toastBC.current.show({
              severity: 'info',
              sticky: true,
              className: 'border-none',
              content: (
                  <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                      <div className="text-center">
                          <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                          <div className="font-bold text-xl my-3">Are you sure?</div>
                      </div>
                      <div className="flex align-items-center">
                          <Button onClick={(e) => handleDelete()} type="button" label="Confirm" className="p-button-success w-6rem" />
                          <Button onClick={(e) => handleDeleteCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                      </div>
                  </div>
              )
            });
          }
        }
      
      };

    const handleSave = (newData) => {
        setSubmitted(true);
        setLoading(true);
        let token = localStorage.getItem('token');
        let header = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }

        if (newData === null) {
            console.log(staffMember);
            let staffMember = {
                "id": 0,
                "member": newMemberNumber,
                "locationId": typeId,
                "overrideLMS": newOverrideLMS
            }
            if(newThisLocation){
                axios.post(`${global.config.url}/staffmembers`, staffMember, header)
                .then(response => {
                    // setSuccess('HubRelay added successfully');
                    msgs.current.show({ severity: 'success', summary: '', detail: 'Staff Member Created', life: 3000 });
                    getStaffMembers();
                })
                .catch(error => {
                    msgs.current.show({ severity: 'error', summary: '', detail: 'Staff Member Creation Failed', life: 3000 });
                })
            }
            else {
                axios.post(`${global.config.url}/staffmembers/alllocations/`, staffMember, header)
                .then(response => {
                    // setSuccess('HubRelay added successfully');
                    msgs.current.show({ severity: 'success', summary: '', detail: 'Staff Member Created for All Locations', life: 3000 });
                    getStaffMembers();
                })
                .catch(error => {
                    msgs.current.show({ severity: 'error', summary: '', detail: 'Staff Member Creation Failed', life: 3000 });
                })
            }
        }
        else {
            console.log(newData.newData);
            let staffMember = {
                "id": newData.newData.id,
                "member": newData.newData.member,
                "locationId": newData.newData.location.id,
                "overrideLMS": editOverrideLMS
            }
            axios.put(`${global.config.url}/staffmembers/${staffMember.id}`, staffMember, header)
                .then(response => {
                    msgs.current.show({ severity: 'success', summary: '', detail: 'Staff Member Updated', life: 3000 });
                    getStaffMembers();
                })
                .catch(error => {
                    msgs.current.show({ severity: 'error', summary: '', detail: 'Staff Member Update Failed', life: 3000 });
                })
        }
        setDisplayDialog(false);
        toastBC.current.clear();
    }

    const handleDelete = () => {
        console.log(selectedStaffMember);
        toastBC.current.clear();
        if(selectedStaffMember === null || selectedStaffMember === undefined || selectedStaffMember.id === 0){
            msgs.current.show({severity: 'error', summary: '', detail: 'Please select a staff member to delete.'});
            setLoading(false);
            setDeleteLoading(false);
            return;
        }
        let token = localStorage.getItem('token');
        let header = {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }
        setLoading(true);
        axios.delete(`${global.config.url}/staffmembers/${selectedStaffMember.id}`, header)
            .then(response => {
                msgs.current.show({ severity: 'success', summary: '', detail: 'Staff Member Deleted', life: 3000 });
                getStaffMembers();
            })
            .catch(error => {
                msgs.current.show({ severity: 'error', summary: '', detail: 'Staff Member Deletion Failed', life: 3000 });
            })
            setLoading(false);
            setDeleteLoading(false);
            toastBC.current.clear();
    }


    const handleCancel = () => {
  
        toastBC.current.clear();
        setLoading(false);
        setDeleteLoading(false);
        setDisplayDialog(false);
        setNewHubRelay(false);
    }

    // const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     setHubRelay({ ...hubRelay, [name]: value });
    // }



    const handleDeleteConfirm = (rowData) => {
        setSelectedStaffMember(rowData);
        setDisplayDialogDelete(true);
    }

    const handleDeleteCancel = () => {
  
        setSelectedStaffMember(null);
        setDisplayDialog(false);
        toastBC.current.clear();
    }

    const endContent = (
        <React.Fragment>
            <span className="p-input-icon-left mr-3 mt-1">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                <Button icon="pi pi-refresh" className="p-button-text" onClick={() => getStaffMembers()} disabled={loading} tooltip="Refresh Staff Members" tooltipOptions={{position: "bottom"}}/>
                <Button icon="pi pi-trash" className="p-button-danger mx-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected staff member" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-plus" className="p-button-success p-mr-2" rounded loading={loading} disabled={loading} onClick={handleAdd} tooltip='Add a new staff member'/>
            </span>
        </React.Fragment>
    );

    const hubRelayDialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={handleCancel} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={() => confirm(true, null)} />
        </div>
    );

    const deleteHubRelayDialogFooter = (
        <div>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={handleDeleteCancel} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={handleDelete} />
        </div>
    );

    const getSeverity = (option) => {
        switch (option) {
            case true:
                return 'success';
    
            case false:
                return 'danger';
    
            case null: 
                return 'warning';
            default:
                return null;
        }
    };

    const allowedBodyTemplate = (ajax) => {
        return <Tag value={ajax.allowed ? "Allowed" : "Not Allowed"} severity={getSeverity(ajax.allowed)}></Tag>;
    };

    const statusBodyTemplate = (relay) => {
        let value = "";
        console.log(relay.status);
        switch(relay.status){
            case true:
                value = "Online";
                break;
            case false:
                value = "Offline";
                break;
            default:
                value = "Unknown";
                break;
        }
        return <Tag value={value} severity={getSeverity(relay.status)}></Tag>;
    };
    const overrideLMSBodyTemplate = (staffmember) => {
        let value = "";
        switch(staffmember.overrideLMS){
            case true:
                value = "Yes";
                break;
            case false:
                value = "No";
                break;
            default:
                value = "Unknown";
                break;
        }
        return <Tag value={value} severity={getSeverity(staffmember.overrideLMS)}></Tag>;
    };

    const textEditor = (options) => {
        console.log(options);
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const allowedEditor = (options) => {
        // console.log(options);
        return <Dropdown
            value={options.rowData.allowed}
            options={statuses}
            onChange={(e) => options.editorCallback(e.value === 'true')}
            placeholder="Select Allowance"
            itemTemplate={(option) => {
                return <Tag value={option} severity={getSeverity(option)}></Tag>;
            }}
        />;
    };
    
    const updateRelayId = (value) => {
        // setNewRelayId(value);
        console.log(value);
    }

    const overrideLMS = (options) => {
        console.log(options);
        
        return <Dropdown
            value={options.rowData.overrideLMS.toString()}
            options={statuses}
            onChange={(e) => { setEditOverrideLMS(e.value === 'true'); options.rowData.overrideLMS = (e.value === 'true'); options.editorCallback(e.value === 'true'); }}
            placeholder="Select Override LMS"
            itemTemplate={(option) => {
                return <Tag value={option} severity={getSeverity(option)}></Tag>;
            }}
        />;
    };

    if (accessIssue) {
        return <AccessState {...accessIssue} />;
    }

    return (
        <Card className ="justify-content-md-center mx-5">
            <Container >
            <div className="card">
                <Toolbar 
                    start={
                    <Container className="flex align-content-center flex-wrap">
                        <Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className='flex'/> 
                        <h4 className='flex mt-2'>Staff Members</h4> 
                    </Container>}
                    end={endContent}/>
                </div>
                <Messages ref={msgs} />
                <Toast ref={toastBC} position="top-center" />
                <div className='justify-content-md-center mt-3'>
                    <DataTable 
                        // ref={dt} 
                        value={staffMembers} selectionMode='single' selection={selectedStaffMember} onSelectionChange={(e) => setSelectedStaffMember(e.value)}
                        dataKey="id"
                        globalFilter={globalFilter} 
                        editMode='row' onRowEditComplete={onRowEditComplete}> 
                        <Column field="member" header="Member" sortable/>
                        <Column field="location.name" header="Location" sortable />
                        <Column header="overrideLMS" body={overrideLMSBodyTemplate} editor={(options) => overrideLMS(options)}></Column>
                        <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                </div>
            </Container>
            <Dialog visible={displayDialog} style={{ width: '450px' }} header="Staff Member Details" modal className="p-fluid" footer={hubRelayDialogFooter} onHide={handleCancel}>
                <Toast ref={toast} />
                <div className="p-field">
                    <label htmlFor="memberNumber">Member Number</label>

                    <InputText id="memberNumber" name="memberNumber" value={newMemberNumber} onChange={(e) => setNewMemberNumber(e.target.value)} required autoFocus  />
                    {submitted && !newMemberNumber && <small className="p-invalid">Member Number is required.</small>}
                </div>

                <div className="p-field mt-3">
                    <p><label>This Location Only</label></p>
                    <InputSwitch id="location" name="location" checked={newThisLocation} onChange={(e) => setNewThisLocation(e.value)}/>
                </div>
                <div className="p-field mt-3">
                    <p><label>All Locations</label></p>
                    <InputSwitch id="allLocations" name="alllocations" checked={!newThisLocation} onChange={(e) => setNewThisLocation(!e.value)}/>
                </div>
                <div className="p-field mt-3">
                    <p><label>Override LMS</label></p>
                    <InputSwitch id="overrideLMS" name="overrideLMS" checked={newOverrideLMS} onChange={(e) => setNewOverrideLMS(e.value)}/>
                </div>
            </Dialog>
            <Dialog visible={displayDialogDelete} style={{ width: '450px' }} header="Confirm" modal footer={deleteHubRelayDialogFooter} onHide={handleDeleteCancel}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {hubRelay && <span>Are you sure you want to delete <b>{hubRelay.ajaxrelayid}</b>?</span>}
                </div>
            </Dialog>
        </Card>
    );
}

export default StaffMembers;



